/* @alwatr/polyfill-has-own v5.0.0 */

// src/main.ts
import { packageTracer } from "@alwatr/package-tracer";
__dev_mode__: packageTracer.add("@alwatr/polyfill-has-own", "5.0.0");
if (Object.prototype.hasOwnProperty.call(Object, "hasOwn") === false) {
  Object.hasOwn = Object.prototype.call.bind(Object.prototype.hasOwnProperty);
}
/*! For license information please see main.mjs.LEGAL.txt */
//# sourceMappingURL=main.mjs.map
